import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BodySmallComponent } from '../body-sm/body-small.component';
import { PopoverComponent } from '../../buttons/popover/popover.component';
@Component({
  selector: 'app-form-label',
  templateUrl: './form-label.component.html',
  styleUrls: ['./form-label.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatTooltipModule,
    BodySmallComponent,
    PopoverComponent
  ]
})
export class FormLabelComponent {
  @Input() requiredField = false;
  @Input() bold?: boolean;
  @Input() popoverHelpText?: string;
  @Input() italic?: boolean;
}
